import Titanic from './images/titanic.jpg'
import Salary from './images/salPred.jpg'
import futureSales from './images/futureSal.png'
import recommendation from './images/movieRecommendation.jpg'
import twitter from './images/twitterSentiment2.jpg'
import Amazon from './images/amazonRev.png'
import CatDog from './images/Dog-vs-Cat.jpg'
import creditRisk from './images/creditRisk.jpg'
import airbnb from './images/airbnbPrice.jpg'
import creditCard from './images/credit-card.jpg'
import carPredict from './images/carPred.jpg'
// can add images for diff cards

const Pdata = [
    {
        imgsrc:Salary,
        title:"Salary Prediction of Data Science Job",
        href:"https://github.com/shoaiburrehman/DS_Salary_Prediction",
        description:"This is the project for Data Science Salary Prediction of Glassdoor's Data Science Job, also deployed it using Flask."
    },
    {
        imgsrc:carPredict,
        title:"Pakistan Used Cars Price Prediction",
        href:"https://github.com/shoaiburrehman/Pakistan-Car-Price-Prediction",
        description:"This is the Pakistan Car Price Prediction Project to Identify Pakistan used Car prices, also deployed it using Flask."
    },
    {
        imgsrc:creditCard,
        title:"Credit Card Fraud Detection",
        href:"https://github.com/shoaiburrehman/Credit-Card-Fraud-Detection",
        description:"This project will identify fraudulent credit card transactions. (with SMOTE & Undersampling Method)."
    },
    {
        imgsrc:Titanic,
        title:"Titanic: Machine Learning From Disaster",
        href:"https://github.com/shoaiburrehman/Titanic_MachineLearning_From_Disaster",
        description:"This is the Titanic Machine Learning from Disaster Project where we predict the survivals. (with Tableau Dashboard)"
    },
    {
        imgsrc:futureSales,
        title:"Predict Future Sales",
        href:"https://github.com/shoaiburrehman/Predict-Future-Sales",
        description:"This is the Predict Future Sales Forecasting Project which predicts from different ML Algorithms for the next month."
    },
    {
        imgsrc:recommendation,
        title:"Movie Recommendation in Python",
        href:"https://github.com/shoaiburrehman/Movie-Recommendation-in-Python",
        description:"This Project is for movie recommendation in python based on Content and Collaborative Filtering."
    },
    {
        imgsrc:twitter,
        title:"Twitter Sentiment Analysis",
        href:"https://github.com/shoaiburrehman/Twitter-Sentiment-Analysis",
        description:"This is the Project for Twitter Sentiment Analysis Dataset uploaded on Kaggle."
    },
    {
        imgsrc:Amazon,
        title:"Amazon Reviews Analysis",
        href:"https://github.com/shoaiburrehman/Amazon-Sentiment-Analysis",
        description:"This is the Project for Amazon Reviews Analysis Dataset uploaded on Kaggle."
    },
    {
        imgsrc:CatDog,
        title:"Dogs vs Cats Image Classification",
        href:"https://github.com/shoaiburrehman/Dogs-vs-Cats-Classification",
        description:"This is the Image Classification Project for Dogs vs Cats Classification Dataset uploaded on Kaggle."
    },
    {
        imgsrc:creditRisk,
        title:"Credit Risk Analysis",
        href:"https://github.com/shoaiburrehman/Credit_Risk_Analysis",
        description:"This is Credit Risk Analysis Machine Learning Project to build a classifier that can efficiently identify bad loans."
    },
    {
        imgsrc:airbnb,
        title:"Airbnb Rental Price Prediction",
        href:"https://github.com/shoaiburrehman/Airbnb-Rental-Price-Prediction",
        description:"This is the NYC Airbnb Rental Price Prediction Project where we have to predict the rent prices of different areas in NYC."
    },
];

export default Pdata;